import { useEffect } from "react";

const LoginInstagram = () => {
	const CLIENT_ID = "1531937851550161";
	const REDIRECT_URI = "https://portal.szsistemas.com.br/auth/instagram/callback";
	const SCOPE = [
		"instagram_business_basic",
		"instagram_business_manage_messages",
		"instagram_business_manage_comments",
		"instagram_business_content_publish",
		"instagram_business_manage_insights",
	].join(",");

	const handleLogin = () => {
		const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
			REDIRECT_URI,
		)}&response_type=code&scope=${encodeURIComponent(SCOPE)}`;

		// window.location.href = authUrl;

		window.open(authUrl, "instagramLogin", "width=600,height=700");
	};

	// Ouvir mensagens vindas do popup
	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data?.source === "instagram-login") {
				// aqui você chama seu reqInstagram.Token(event.data.code)
			}
		};

		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	}, []);

	return (
		<div>
			<h2>Login com Instagram</h2>
			<button onClick={handleLogin}>Conectar Instagram</button>
		</div>
	);
};

export default LoginInstagram;

// const LoginInstagram = () => {
// 	const CLIENT_ID = "1531937851550161";
// 	const REDIRECT_URI = "https://portal.szsistemas.com.br/auth/instagram/callback";
// 	const SCOPE = "user_profile,user_media";

// 	const handleLogin = () => {
// 		const authUrl = `https://api.instagram.com/oauth/authorize
//       ?client_id=${CLIENT_ID}
//       &redirect_uri=${encodeURIComponent(REDIRECT_URI)}
//       &scope=${SCOPE}
//       &response_type=code`;

// 		window.location.href = authUrl;
// 	};

// 	return (
// 		<div>
// 			<h2>Login com Instagram</h2>
// 			<button onClick={handleLogin}>Conectar Instagram</button>
// 		</div>
// 	);
// };

// export default LoginInstagram;
